import TagManager, { TagManagerArgs } from 'react-gtm-module'
import { useMount } from 'react-use'

/**
 * Google Tag Manager (GTM)
 */
export const useGTM = (settings: TagManagerArgs) => {
  useMount(() => {
    if (__ENV__ === 'staging') {
      return
    }
    TagManager.initialize(settings)
  })
}
